import styled from 'styled-components';

import Icon from '@ant-design/icons';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  fontSize: '20rem',
  fontFamily: 'Arial',

  width: '100%',
  marginTop: '20rem',
  marginBottom: '20rem',

  '& > *': {
    marginRight: '5rem',
  },
});

export const DrawIcon = styled(Icon)({
  width: '45rem',
  marginLeft: '20rem',
});
